
<div class="right-side p-5"> 
  <div class="section">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="card mb-3">
        <div class="card-header"><h2>Create New Proposal Works!</h2></div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-3">
              <label for="proposalId">Proposal ID:</label><br />
              <label for="proposalId">IA0001</label>
            </div>
            <div class="col-md-3">
              <label for="intervention">Intervention:</label>
              <select id="intervention" formControlName="intervention" class="form-select">
                <option *ngFor="let option of interventionOptions" [value]="option">{{ option }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="component">Component:</label>
              <select id="component" formControlName="component" class="form-select">
                <option *ngFor="let option of componentOptions" [value]="option">{{ option }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="targetMSME">Target MSME:</label>
              <input id="targetMSME" type="number" formControlName="targetMSME" class="form-control" />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-3">
              <label for="noOfEvents">No. of Events:</label>
              <input id="noOfEvents" type="number" formControlName="noOfEvents" class="form-control" />
            </div>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-header"><h2>Implementation Agency Details</h2></div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-3">
              <label for="proposalId">Brief Background of the Implementing Agency</label>
              <input id="briefBackgroundofIA" type="text" formControlName="briefBackgroundofIA" class="form-control" />
            </div>
            <div class="col-md-3">
              <label for="intervention">Summary and Scale of projects implemented in the last 3 years</label>
              <input id="summaryScale" type="text" formControlName="summaryScale" class="form-control" />
            </div>
            <div class="col-md-3">
              <label for="component">Program Name to be conducted</label>
              <input id="programName" type="text" formControlName="programName" class="form-control" />
            </div>
            <div class="col-md-3">
              <label for="targetMSME">Target MSMEs</label>
              <input id="targetMSMEs" type="text" formControlName="targetMSMEs" class="form-control" />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-3">
              <label for="measurableOutcoms">Measurable Outcomes</label>
              <input id="measurableOutcoms" type="text" formControlName="measurableOutcoms" class="form-control" />
            </div>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-header"><h2>Implementation Details</h2></div>
        <div class="card-body">
          <div formArrayName="implementationDetails">
            <div *ngFor="let detail of implementationDetails.controls; let i = index" [formGroupName]="i" class="row mb-3">
              <div class="col-md-3">
                <label for="engagementPartner-{{i}}">Engagement Partner Name</label>
                <input id="engagementPartner-{{i}}" type="text" formControlName="engagementPartner" class="form-control" />
              </div>
              <div class="col-md-3">
                <label for="district-{{i}}">District</label>
                <select id="district-{{i}}" formControlName="district" class="form-select">
                  <option *ngFor="let option of interventionOptions" [value]="option">{{ option }}</option>
                </select>
              </div>
              <div class="col-md-3">
                <label for="noOfWorkshop-{{i}}">No. of Workshops:</label>
                <input id="noOfWorkshop-{{i}}" type="number" formControlName="noOfWorkshop" class="form-control" />
              </div>
              <div class="col-md-3">
                <label for="target-{{i}}">Target</label>
                <input id="target-{{i}}" type="number" formControlName="target" class="form-control" />
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <button type="button" (click)="addMore()" class="btn btn-primary btn-sm">Add More</button>
              <button type="submit" [disabled]="form.invalid" class="btn btn-success btn-sm mx-1">Save</button>
              <button type="button" (click)="onCancel()" class="btn btn-danger btn-sm">Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-header"><h2>Geography & Timeline</h2></div>
        <div class="card-body">
          <div formArrayName="geographyTimeline">
            <div *ngFor="let location of geographyTimeline.controls; let i = index" [formGroupName]="i" class="row mb-3">
              <div class="col-md-3">
                <label for="proposedDate-{{i}}">Proposed Date of Training</label>
                <input id="proposedDate-{{i}}" type="text" formControlName="proposedDate" class="form-control" />
              </div>
              <div class="col-md-3">
                <label for="proposedDistrict-{{i}}">Proposed District</label>
                <input id="proposedDistrict-{{i}}" type="text" formControlName="proposedDistrict" class="form-control" />
              </div>
              <div class="col-md-3">
                <label for="proposedVenue-{{i}}">Proposed Venue (Training location)</label>
                <input id="proposedVenue-{{i}}" type="text" formControlName="proposedVenue" class="form-control" />
              </div>
              <div class="col-md-3">
                <label for="proposedNoOfWorkshop-{{i}}">Proposed No. of Workshops per Location</label>
                <input id="proposedNoOfWorkshop-{{i}}" type="text" formControlName="proposedNoOfWorkshop" class="form-control" />
              </div>
              <div class="col-md-3">
                <label for="totalTarget-{{i}}">Total Target</label>
                <input id="totalTarget-{{i}}" type="text" formControlName="totalTarget" class="form-control" />
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-12">
              <button type="button" (click)="addGeographyTimeline()" class="btn btn-primary btn-sm">Add More</button>
              <button type="button" (click)="saveForm()" class="btn btn-success btn-sm mx-1">Save</button>
              <button type="button" (click)="onCancel()" class="btn btn-danger btn-sm">Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-header"><h2>Training Delivery</h2></div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-3">
              <label for="curriculumDetails">Details of Curriculum Design/Course Content</label>
              <input id="curriculumDetails" type="text" formControlName="curriculumDetails" class="form-control" />
            </div>
            <div class="col-md-3">
              <label for="workshopDuration">Duration of Workshop (Hours) for each category</label>
              <input id="workshopDuration" type="text" formControlName="workshopDuration" class="form-control" />
            </div>
            <div class="col-md-3">
              <label for="trainersQualification">Qualification of Trainers</label>
              <input id="trainersQualification" type="text" formControlName="trainersQualification" class="form-control" />
            </div>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-header"><h2>Beneficiaries</h2></div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-3">
              <label for="beneficiaryCriteria">Selection Criteria of Beneficiaries</label>
              <input id="beneficiaryCriteria" type="text" formControlName="beneficiaryCriteria" class="form-control" />
            </div>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-header">
          <h2>Certification Detailed Financials (Cost Bifurcation for each workshop/training)</h2>
        </div>
        <div class="card-body">
          <div formArrayName="detailedFinancials">
            <div *ngFor="let detail of detailedFinancials.controls; let i = index" [formGroupName]="i" class="row mb-3">
              <div class="col-md-3">
                <label for="budgetHead-{{i}}">Budget Head</label>
                <select id="district-{{i}}" formControlName="district" class="form-select">
                  <option *ngFor="let option of interventionOptions" [value]="option">{{ option }}</option>
                </select>
              </div>
              <div class="col-md-3">
                <label for="cost-{{i}}">Cost</label>
                <input id="cost-{{i}}" type="number" formControlName="cost" class="form-control" />
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <button type="button" (click)="addDetailedFinancial()" class="btn btn-primary btn-sm">Add More</button>
              <button type="button" (click)="saveForm()" class="btn btn-success btn-sm mx-1">Save</button>
              <button type="button" (click)="onCancel()" class="btn btn-danger btn-sm">Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-header"><h2>Intervention Milestones</h2></div>
        <div class="card-body">
          <div formArrayName="interventionMilestones">
            <div *ngFor="let detail of interventionMilestones.controls; let i = index" [formGroupName]="i" class="row mb-3">
              <div class="col-md-3">
                <label for="milestone-{{i}}">Milestone</label>
                <input id="milestone-{{i}}" type="text" formControlName="milestone" class="form-control" />
              </div>
              <div class="col-md-3">
                <label for="projectStartDate-{{i}}">Project Start Date</label>
                <input id="projectStartDate-{{i}}" type="date" formControlName="projectStartDate" class="form-control" />
              </div>
              <div class="col-md-3">
                <label for="durationInMonths-{{i}}">Duration in months</label>
                <input id="durationInMonths-{{i}}" type="text" formControlName="durationInMonths" class="form-control" />
              </div>
              <div class="col-md-3">
                <label for="estimatedProjectClosure-{{i}}">Estimated project Closure</label>
                <input id="estimatedProjectClosure-{{i}}" type="text" formControlName="estimatedProjectClosure" class="form-control" />
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <button type="button" (click)="addMore()" class="btn btn-primary btn-sm">Add More</button>
              <button type="submit" [disabled]="form.invalid" class="btn btn-success btn-sm mx-1">Save</button>
              <button type="button" (click)="onCancel()" class="btn btn-danger btn-sm">Cancel</button>
            </div>
          </div>
        </div>
      </div>

      
     
      <div class="col-md-12 text-center"><button type="submit" [disabled]="form.invalid" class="btn btn-success">Submit</button></div>
    </form>
  </div>
</div>
